export default __webpack_public_path__ + "static/media/hht2_ep06_timeline_08.7caa3e57.png";